<template>
  <div class="is-border">
    <table-h-scroll :sticky-styles="stickyStyles" :has-sticky="hasSticky"
                    :sticky-datas="stickyDatas" :reload-controls="programs">
      <table class="table is-fullwidth is-narrow is-striped-v is-first-fixed-small is-last-fixed-small is-marginless-bottom has-actionsontd">
        <thead>
          <tr class="is-size-6">
            <th class="is-paddingless has-text-centered actions" style="z-index: 2;">
              <div v-if="!multiselection"
                class="dropdown is-hoverable is-left">
                <div class="dropdown-trigger">
                  <button class="button is-circle is-small" aria-haspopup="true" aria-controls="dropdown-menu">
                    <i class="fal fa-cog"></i>
                  </button>
                </div>
                <columns-toggles :entries="columnsList" :source="columns" @update="updateColumns"></columns-toggles>
              </div>
              <button v-else class="button is-small is-light is-circle" @click="$emit('selectItemToggleAll', programs)">
                <span class="icon"><i class="far fa-check-double"></i></span>
              </button>
            </th>
            <th class="is-groupcols-1a">
              <sortable @sort="sort('name', $event, sortBy)" :sort="sortBy.name" label="Nom"></sortable>
              <div class="deco"></div>
            </th>
            <th v-if="isDistributeurMode && !isExternal && showColumn('promotor_name')" class="is-groupcols-1a">
              <sortable @sort="sort('promoteur_name', $event, sortBy)" :sort="sortBy.promoteur_name" label="Promoteur"></sortable>
              <div class="deco"></div>
            </th>
            <th v-if="(isAdmin || isEditor) && showColumn('status')" class="is-groupcols-1a">Statut<div class="deco"></div></th>
            <th v-if="showColumn('tax_dispositifs')" class="is-groupcols-2a">Dispositifs<div class="deco"></div></th>
            <th v-if="showColumn('zip_code')" class="is-groupcols-2b">Code Postal<div class="deco"></div></th>
            <th v-if="showColumn('city')" class="is-groupcols-2b">Ville<div class="deco"></div></th>
            <th v-if="showColumn('date_livraison')" class="is-groupcols-2a">
              <sortable @sort="sort('date_livraison', $event, sortBy)" :sort="sortBy.date_livraison" label="Livraison"></sortable>
              <!-- Livraison -->
              <div class="deco"></div>
            </th>
            <th v-if="showColumn('date_actabilite')" class="is-groupcols-2a">
              <sortable @sort="sort('date_actabilite', $event, sortBy)" :sort="sortBy.date_actabilite" :label="actabilityTerm"></sortable>
              <!-- Actable -->
              <div class="deco"></div>
            </th>
            <th v-if="!(isDistributeurMode && isExternal) && showColumn('lot_dispo')" class="is-groupcols-2b">
              Lots dispo<div class="deco"></div>
            </th>
            <th v-if="!isExternal && showColumn('lot_total')" class="is-groupcols-2b">
              <sortable @sort="sort('lot_counts__total', $event, sortBy)" :sort="sortBy.lot_counts__total"
                        label="Lots Total"></sortable>
              <!-- Lots Total -->
              <div class="deco"></div>
            </th>
            <th v-if="!isExternal && showColumn('remuneration') && displayRemuneration" class="is-groupcols-2a">
              <sortable @sort="sort('remuneration', $event, sortBy)" :sort="sortBy.remuneration"
                        label="Rémunération"></sortable>
              <div class="deco"></div>
            </th>
            <th v-if="showColumn('progress_step')" class="is-groupcols-1a">
              État d'avancement <div class="deco"></div>
            </th>
            <th v-if="(isAdmin || isEditor) && showColumn('diffusion_enabled')"
                class="is-groupcols-2a">
              <sortable @sort="sort('diffusion_enabled', $event, sortBy)" :sort="sortBy.diffusion_enabled"
                        label="Multi-diff."></sortable>
              <div class="deco"></div>
            </th>
            <th v-if="(isAdmin || isEditor) && showColumn('created_on')">
              <sortable @sort="sort('created_on', $event, sortBy)" :sort="sortBy.created_on"
                        label="Création"></sortable>
                <!-- Création -->
              <div class="deco"></div>
            </th>
            <th class="has-text-centered"></th>
          </tr>
        </thead>
        <tbody>
          <stock-program-list-item v-for="(program, i) in programs"
                                   :source="program"
                                   :key="program.program"
                                   :i="i"
                                   :multiselection="multiselection"
                                   :columnsShowSource="columnsShow"
                                   :columnsSource="columns"
                                   :programsCount="programs.length"
                                   :selectedItems="selectedItems"
                                   :currentProgramPage="currentProgramPage"
                                   @reload="$emit('reload')"
                                   @selected="selected"
          ></stock-program-list-item>
        </tbody>
        <tbody>
          <tr class="empty empty--row" v-for="n in programs.length < 4 ? 4 - programs.length : 0 " :key="n"><td class="is-borderless"></td></tr>
        </tbody>
      </table>
    </table-h-scroll>
    <div class="is-border-top" v-if="totalPage > 1 && nextPage">
      <a class="button is-light is-fullwidth has-text-grey" @click="$emit('loadMore', fromClick)" v-if="!infiniteLoading">
        <span class="icon is-small is-size-6"><i class="fas fa-chevron-down"></i></span>
        <span class="is-size-6">Afficher la suite</span>
      </a>
      <div class="has-text-centered" v-else><img src="static/spinner2.svg" alt="spinner" style="height: 38px"></div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { DefaultValues, ColumnConf, TableHeaderSticky } from '../../mixins'
  import StockProgramListItem from './StockProgramListItem'

  export default {
    name: 'StockProgramList',
    mixins: [DefaultValues, ColumnConf, TableHeaderSticky],
    components: {StockProgramListItem},
    props: {
      source: {
        type: Array,
        required: true
      },
      multiselection: {
        type: Boolean,
        default: false
      },
      paramsList: Object,
      selectedItems: {
        type: Array,
        default: () => []
      },
      totalPageParams: Number,
      infiniteLoadingParams: Boolean,
      currentProgramPage: Number
    },
    data () {
      return {
        infiniteLoading: false,
        service: this.$api.programService,
        columnsConfResource: 'program',
        hasSticky: true,
        infiniteLoaderEnabled: true,
        fromClick: true
      }
    },
    computed: {
      ...mapState(['configs']),
      ...mapGetters(['isAdmin', 'isSeller', 'isManager', 'isEditor', 'isExternal', 'isDistributeurMode', 'displayRemuneration']),
      sortBy () {
        return this.paramsList.sortBy
      },
      nextPage () {
        if (!this.currentProgramPage || !this.totalPageParams) {
          return null
        } else {
          if (this.currentProgramPage && this.totalPageParams && this.totalPageParams > this.currentProgramPage) {
            return this.currentProgramPage + 1
          } else {
            return null
          }
        }
      },
      programs () {
        return this.source
      },
      actabilityTerm () {
        if (!this.configs) return
        let term = {
          FRA: 'Actable',
          MAR: 'Titre foncier'
        }
        return term[this.configs.COUNTRY]
      },
      columnsShow () {
        const columns = {}
        if (!this.isExternal && this.isDistributeurMode) {
          columns.promotor_name = {label: 'Promoteur', mobile: true}
        }
        if (this.isAdmin || this.isEditor) {
          columns.status = {label: 'Statut', mobile: true}
        }
        columns.tax_dispositifs = {label: 'Dispositifs', mobile: true}
        columns.zip_code = {label: 'Code Postal', mobile: true}
        columns.city = {label: 'Ville', mobile: true}
        columns.date_livraison = {label: 'Livraison', mobile: false}
        if (this.configs) {
          let term = {
            FRA: 'Actable',
            MAR: 'Titre foncier'
          }
          let labelActable = term[this.configs.COUNTRY]
          columns.date_actabilite = {label: labelActable, mobile: false}
        }
        if (!(this.isDistributeurMode && this.isExternal)) {
          columns.lot_dispo = {label: 'Lots Disponible', mobile: true}
        }
        if (!this.isExternal) {
          columns.lot_total = {label: 'Lots Total', mobile: true}
        }
        if (!this.isExternal && this.displayRemuneration) {
          columns.remuneration = {label: 'Rémunération', mobile: false}
        }
        columns.progress_step = {label: 'État d\'avancement', mobile: true}
        if (this.isAdmin || this.isEditor) {
          columns.diffusion_enabled = {label: 'Multi-diff.', mobile: false}
        }
        if (this.isAdmin || this.isEditor) {
          columns.created_on = {label: 'Création', mobile: false}
        }
        return columns
      }
    },
    watch: {
      programs (val) {
        this.tickingSticky()
      },
      infiniteLoadingParams () {
        this.infiniteLoading = this.infiniteLoadingParams
      }
    },
    methods: {
      sort (key, e, sortBy) {
        this.$emit('sort', {key, sort: e.order, e, sortBy})
      },
      selected (v, id) {
        v.data = id
        this.$emit('selectItem', v)
      },
      selectItemToggleAll (items) {
        this.$emit('selectItemToggleAll', items)
      }
    },
    created () {
      this.totalPage = this.totalPageParams
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/stock/StockProgramList.vue